export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/ubuntu-service-stack-form';
